import { z } from 'zod';
import { ColorSchema, LOOK, SourceRefSchema, about, icon, sourceOf } from '../schema_fields.ts';
import { TileStyleSchema } from '../tile_style.ts';

/**
 * A switch (legacy `SwitchTile`): like a light, on or off from its source and switched by a tap,
 * shown by an icon for each state in a colour for each (legacy `OnOffTileOptions`). It never dims
 * (the owner, 2026-10-15). A tile style for each state goes over the tile's own (tiles spec SW-1).
 */
export const SwitchOptionsSchema = z.object({
    source: sourceOf(SourceRefSchema, { gives: ['onOff'], label: 'Device' }),
    onIcon: icon('Icon when on', 'toggle-large-on'),
    offIcon: icon('Icon when off', 'toggle-large-off'),
    onColor: ColorSchema.default('#ffff00').meta({ ...about('Colour when on', undefined, 'color'), ...LOOK }),
    offColor: ColorSchema.default('#808080').meta({ ...about('Colour when off', undefined, 'color'), ...LOOK }),
    onStyle: TileStyleSchema.optional().meta(about('Tile style when on', 'the tile\'s style while it is on, over its own', 'tile-style')),
    offStyle: TileStyleSchema.optional().meta(about('Tile style when off', 'the tile\'s style while it is off or not yet known, over its own', 'tile-style')),
});
